module.exports = __webpack_public_path__ + "static/img/15.fe7fa165.jpg";